import LoadingScreen from 'components/LoadingScreen';
import { VersionNotifier } from 'components/VersionNotifier';
import useAuth from 'hooks/useAuth';
import { useNotificationVersion } from 'hooks/useNotificationVersion';
import AuthLayout from 'layouts/AuthLayout';
import EmailPageContainer from 'pages/email_send_page/skeleton/EmailPageContainer';
import { ReactNode, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'redux/store';

type AuthGuardProps = {
  children: ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { allowed, isLoading } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);
  const customer = useSelector((state: any) => state.customer.customer);
  // poll server version and return flag when newer build is available
  const hasNewVersion = useNotificationVersion();

  useEffect(() => {
    if (!allowed || !localStorage.getItem('token')) {
      if (pathname !== requestedLocation) {
        setRequestedLocation(pathname);
      }
    }
  }, []);

  if (allowed && localStorage.getItem('token')) {
    const currentCustomerId = window.location.pathname.split('/')[1];
    if (!customer?.isOnboardingDone && pathname !== `/${currentCustomerId}/onboarding`) {
      return <Navigate to={'/' + currentCustomerId + '/onboarding'} />;
    }
  }

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!allowed || !localStorage.getItem('token')) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return (
      <AuthLayout>
        <EmailPageContainer />
      </AuthLayout>
    );
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return (
    <>
      {' '}
      {/* notify user when a newer version/build is available */}
      <VersionNotifier isOpen={hasNewVersion} />
      {children}
    </>
  );
}
